import { useParams } from 'react-router-dom';
import { useRequest } from '@/hooks';

export default function useChatbot() {
  const { appId, projectId, chatbotId, sceneId } = useParams<AppParam>();

  const {
    data: items,
    isValidating,
    mutate
  } = useRequest<Chatbot[]>(`/apps/${appId}/projects/${projectId}/chatbots`);

  const itemIndex = items?.findIndex((chatbot) => chatbot.id === chatbotId);
  const item = items && typeof itemIndex === 'number' ? items[itemIndex] : undefined;
  const sceneIndex = item?.scenes?.findIndex((scene) => scene.id === sceneId);
  const scene =
    item && item.scenes && typeof sceneIndex === 'number' ? item.scenes[sceneIndex] : undefined;

  return { items, item, itemIndex, sceneIndex, scene, isValidating, mutate };
}
